module.exports = __webpack_public_path__ + "img/logoPetco.a35dd1cb.png";